import React from 'react';
import { UniversalCalculator } from './UniversalCalculator';
import { sipUniversalConfig } from './universalCalculatorConfigs';

export const SIPCalculator: React.FC = () => {
  return <UniversalCalculator config={sipUniversalConfig} />;
};
